import { render, staticRenderFns } from "./HotspotsTab.vue?vue&type=template&id=5769bba6&scoped=true"
import script from "./HotspotsTab.vue?vue&type=script&lang=ts"
export * from "./HotspotsTab.vue?vue&type=script&lang=ts"
import style0 from "./HotspotsTab.vue?vue&type=style&index=0&id=5769bba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5769bba6",
  null
  
)

export default component.exports